import tw, { styled } from 'twin.macro'
import React, { Component } from 'react'
import { Link } from 'gatsby'
import { Heading, SubHeading, SubHeadingBold } from './Typography'
import ButtonLink from './ButtonLink'

/* eslint-disable */
Number.prototype.formatMoney = function (c, d, t) {
  var n = this;

  if (n < 10) {
    var rounded = Math.ceil(n); // Round up to nearest whole integer

    if (n !== rounded) {
      c = 0; // Remove decimals
    }

    n = rounded;
  }

  var c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

Number.prototype.withCommas = function() {
  return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
/* eslint-enable */

const Wrapper = styled('div')`
  ${tw`container mx-auto p-6 my-6 bg-white rounded-3xl ring-1 ring-gray-200`};
`

const CostWrapper = styled('div')`
  ${tw`mb-8`};
`

const AnchorLink = styled('a')`
  ${tw`text-gray-900 mr-2 hover:text-red-500 text-base`};
`

const Tabs = styled('div')`
  ${tw`sm:flex justify-center`};
`

const Columns = styled('div')`
  ${tw`sm:flex`};
`

const LeftColumn = styled('div')`
  ${tw`sm:w-1/2 text-center`};
`

const RightColumn = styled('div')`
  ${tw`sm:w-1/2 text-center sm:flex flex-col items-center justify-center mt-8 sm:mt-0`};
`

const ListSizeContainer = styled('div')`
  ${tw`flex justify-start items-center w-3/4 mx-auto mb-4`}
`

const EstimateInput = styled('input')`
  ${tw`appearance-none rounded-lg py-2 px-3 mr-3 bg-gray-100 leading-tight border-solid border-gray-400 text-lg text-gray-800 w-3/4 focus:outline-none focus:border-red-500 font-light`}
`

const DataAppends = styled('div')`
  ${tw`flex flex-wrap`}
`

const DataAppend = styled('button')`
  ${tw`uppercase block no-underline border border-solid rounded-lg text-center border-gray-500 my-1 lg:my-3 px-3 py-2 text-xs lg:mt-0 xl:-mt-1 lg:mx-3 lg:px-4 lg:py-2 w-full h-10 lg:w-48 lg:h-12 xl:w-64 cursor-pointer focus:outline-none`}
  i {
    ${tw`mr-2`}
  }

  ${props => props.selected ? tw`bg-teal-500 text-white hover:bg-teal-400 focus:bg-teal-500 focus:text-white` : tw`hover:bg-gray-200 hover:text-black`}
`

const Divider = styled('hr')`
  ${tw`my-4`}
`

const CallOut = styled('p')`
  ${tw`my-2 rounded-md bg-blue-100 p-4 text-sm`}
`

const COST_PER_QUERY = 0.0005;
const FREE_LOOKUPS_PER_DAY = 2500;
const DAYS_IN_MONTH = 30;
const THROUGHPUT_PER_HOUR = 500000;

const tiers = [
  {
    amount: 250000,
    discount: 0.05
  },
  {
    amount: 500000,
    discount: 0.10
  },
  {
    amount: 1000000,
    discount: 0.15
  },
  {
    amount: 1500000,
    discount: 0.25
  },
  {
    amount: 2000000,
    discount: 0.30
  },
  {
    amount: 3000000,
    discount: 0.40
  },
  {
    amount: 5000000,
    discount: 0.50
  },
  {
    amount: 10000000,
    discount: 0.60
  },
  {
    amount: 15000000,
    discount: 0.70
  },
  {
    amount: 25000000,
    discount: 0.80
  },
  {
    amount: 30000000,
    discount: 0.85
  }
];

class PricingCalculator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: 'one-time', // or recurring
      volumeAmount: '',
      showDiscountDisclaimer: false,
      totalCost: null,
      dataAppends: [],
    }
  }

  calculateNewCost(volumeAmount, isRecurring, numberOfDataAppends) {
    const val = volumeAmount.replace(/\D/g,'');
    const amount = parseInt(val, 10);

    // Don't try to calculate anything with a blank field
    if (!val || val.length <= 0 || isNaN(amount)) {
      return { description: null, showDiscountDisclaimer: false };
    }

    // Only update if changed
    if (volumeAmount !== amount.withCommas()) {
      this.setState({volumeAmount: amount.withCommas()});
    }

    const additionalLookupsAmount = amount * numberOfDataAppends;

    return isRecurring
      ? this.getCostRecurringDescription(amount, additionalLookupsAmount)
      : this.getCostOneTimeDescription(amount, additionalLookupsAmount);
  }

  getCostRecurringDescription(amount, additionalLookupsAmount) {
    const totalAmount = amount - (FREE_LOOKUPS_PER_DAY * DAYS_IN_MONTH) + additionalLookupsAmount;
    const totalAmountWorstCase = amount + additionalLookupsAmount - FREE_LOOKUPS_PER_DAY;

    const result = this.calculateCost(totalAmount);
    const resultWorstCase = this.calculateCost(totalAmountWorstCase);

    const pricingDisclaimer = ( <h5>Best/worst case price, depending on usage pattern.<br />(First 2,500 lookups/day are free)</h5> );

    let description = null;
    let showDiscountDisclaimer = false;

    if (totalAmount <= 0) {
      description = (amount + additionalLookupsAmount < FREE_LOOKUPS_PER_DAY)
        ? ( <SubHeading>Free</SubHeading> )
        : ( <div>
              <SubHeading>Free - ${resultWorstCase.cost.formatMoney()}/month</SubHeading>
              {pricingDisclaimer}
            </div>
          );
    } else if (result.cost >= 1000) {
      description = (
        <div>
          <SubHeading>Choose <strong>Geocodio Unlimited</strong></SubHeading><h3>Unlimited lookups for $1,000/month</h3>
          <p>or ${result.cost.formatMoney()}/month - ${resultWorstCase.cost.formatMoney()}/month with Pay as You Go</p>
        </div>
      );

    } else {
      showDiscountDisclaimer = (result.discount > 0.0);

      description = (
        <div>
          <SubHeading>
            ${result.cost.formatMoney()}/month - ${resultWorstCase.cost.formatMoney()}/month
            {result.discount > 0.0 ? ( <p><em>{result.discount * 100}% volume discount</em></p> ) : null}
          </SubHeading>
          {pricingDisclaimer}
        </div>
      );
    }

    return { description, showDiscountDisclaimer };
  }

  getCostOneTimeDescription(amount, additionalLookupsAmount) {
    let totalAmount = amount - FREE_LOOKUPS_PER_DAY;
    totalAmount += additionalLookupsAmount;

    const description = [];
    let showDiscountDisclaimer = false;

    if (additionalLookupsAmount > 0) {
      description.push( <SubHeading key="title">{amount.withCommas()} lookups + {additionalLookupsAmount.withCommas()} data appends = {(amount + additionalLookupsAmount).withCommas()} lookups</SubHeading> );
    } else {
      description.push( <SubHeading key="title">{amount.withCommas()} lookups</SubHeading> );
    }
    description.push( <Divider key="spacer" /> );

    if (totalAmount >= 30000000) {
      description.push( <SubHeadingBold key="subtitle">Please <a href="mailto:hello@geocod.io">contact us</a> for a custom quote.</SubHeadingBold> );
    } else {
      const result = this.calculateCost(totalAmount);
      showDiscountDisclaimer = (result.discount > 0.0);

      description.push(
        <SubHeadingBold key="cost-title">Total cost</SubHeadingBold>
      );

      description.push(
        <SubHeading key="cost">
          {' '}
          {result.discount > 0.0 ? ( <s>${result.originalCost.formatMoney()}</s> ) : null}
          {result.discount > 0.0 ? ( <p><em>{(result.discount * 100)}% volume discount</em></p> ) : null}
          <span tw="underline border-b border-black">${result.cost.formatMoney()}</span>
        </SubHeading>
      );

      const processingTime = this.calculateProcessingTime(amount + additionalLookupsAmount);

      if (processingTime !== 'n/a') {
        description.push( <SubHeadingBold key="time-title">Processing time</SubHeadingBold> );
        description.push( <SubHeading key="time">{processingTime}</SubHeading> );
      }
    }

    return { description, showDiscountDisclaimer };
  }

  calculateCost(amount) {
    const originalCost = amount * COST_PER_QUERY; // Start with the regular cost
    let cost = originalCost;
    let discount = 0;

    // Loop through tiers backwards
    for (let i = tiers.length - 1; i >= 0; i--) {
      if (amount >= tiers[i].amount) { // Does the amount match this tier?
        // Apply discount
        cost *= (1 - tiers[i].discount);
        discount = tiers[i].discount;
        break;
      }
    }

    if (cost < 0) {
      cost = 0;
    }

    return {
      originalCost: originalCost,
      cost: cost,
      discount: discount
    };
  }

  calculateProcessingTime(amount) {
    if (amount <= 0) {
      return 'n/a';
    }

    const seconds = (3600 / THROUGHPUT_PER_HOUR) * amount;

    if (seconds < (60 * 5)) {
      return 'a few minutes';
    } else if (seconds < (60 * 15)) {
      return 'less than 15 minutes';
    } else if (seconds < (60 * 30)) {
      return 'less than 30 minutes';
    } else {
      const hours = Math.ceil(seconds / 3600);
      return 'about ' + hours + ' ' + (hours === 1 ? 'hour' : 'hours');
    }
  }

  render() {
    return (
      <Wrapper id="pricing-calculator">
        <Heading>
          <AnchorLink href="#pricing-calculator"><i className="fa fa-link"></i></AnchorLink>
          Pay-As-You-Go Pricing Calculator
        </Heading>

        <h6 tw="italic text-lg text-center mb-2">
          Please note, this pricing only applies to our standard product, and not our HIPAA/HITECH-compliant Enterprise product.
        </h6>

        <Tabs>
          <ButtonLink onClick={() => this.handleTabChanged('one-time')} red={this.state.mode === 'one-time'} special={this.state.mode !== 'one-time'}><i className="fa fa-list"></i> One-Time</ButtonLink>
          <ButtonLink onClick={() => this.handleTabChanged('recurring')} red={this.state.mode === 'recurring'} special={this.state.mode !== 'recurring'}><i className="fa fa-refresh"></i> Recurring</ButtonLink>
        </Tabs>

        <Columns>
          <LeftColumn>
            <SubHeading>{this.state.mode === 'one-time' ? 'Number of records (addresses/coordinate pairs) to geocode' : 'What is your estimated volume?'}</SubHeading>

            <ListSizeContainer>
              <EstimateInput type="text" placeholder="e.g. 250,000" onChange={this.handleEstimateChange} value={this.state.volumeAmount} />
              {this.state.mode === 'one-time' ? 'rows' : (<span>lookups/<strong>month</strong></span>)}
            </ListSizeContainer>

            <SubHeading>
              {this.state.mode === 'one-time' ? 'Do you want any data appends?' : 'Additional data appends per lookup'}
            </SubHeading>
            <DataAppends>
              <DataAppend onClick={() => this.handleDataAppendClicked('Census Data')} selected={this.state.dataAppends.indexOf('Census Data') !== -1}>
                <i className="fa fa-area-chart"></i>
                Census Identifiers
              </DataAppend>
              <DataAppend onClick={() => this.handleDataAppendClicked('Congressional Districts')} selected={this.state.dataAppends.indexOf('Congressional Districts') !== -1}>
                <i className="fa fa-map-o"></i>
                Congressional Districts
              </DataAppend>
              <DataAppend onClick={() => this.handleDataAppendClicked('State Legislative Districts')} selected={this.state.dataAppends.indexOf('State Legislative Districts') !== -1}>
                <i className="fa fa-gavel"></i>
                State Legislative Districts
              </DataAppend>
              <DataAppend onClick={() => this.handleDataAppendClicked('School Districts')} selected={this.state.dataAppends.indexOf('School Districts') !== -1}>
                <i className="fa fa-graduation-cap"></i>
                School Districts
              </DataAppend>
              <DataAppend onClick={() => this.handleDataAppendClicked('Timezone')} selected={this.state.dataAppends.indexOf('Timezone') !== -1}>
                <i className="fa fa-clock-o"></i>
                Timezone
              </DataAppend>

              <DataAppend onClick={() => this.handleDataAppendClicked('Census ACS Demographics')} selected={this.state.dataAppends.indexOf('Census ACS Demographics') !== -1}>
                <i className="fa fa-pie-chart"></i>
                Census ACS Demographics
              </DataAppend>
              <DataAppend onClick={() => this.handleDataAppendClicked('Census ACS Families')} selected={this.state.dataAppends.indexOf('Census ACS Families') !== -1}>
                <i className="fa fa-users"></i>
                Census ACS Families
              </DataAppend>
              <DataAppend onClick={() => this.handleDataAppendClicked('Census ACS Economics')} selected={this.state.dataAppends.indexOf('Census ACS Economics') !== -1}>
                <i className="fa fa-money"></i>
                Census ACS Economics
              </DataAppend>
              <DataAppend onClick={() => this.handleDataAppendClicked('Census ACS Housing')} selected={this.state.dataAppends.indexOf('Census ACS Housing') !== -1}>
                <i className="fa fa-home"></i>
                Census ACS Housing
              </DataAppend>
              <DataAppend onClick={() => this.handleDataAppendClicked('Census ACS Social')} selected={this.state.dataAppends.indexOf('Census ACS Social') !== -1}>
                <i className="fa fa-user-secret"></i>
                Census ACS Social
              </DataAppend>

              <DataAppend onClick={() => this.handleDataAppendClicked('USPS ZIP+4')} selected={this.state.dataAppends.indexOf('USPS ZIP+4') !== -1}>
                <i className="fa fa-envelope"></i>
                USPS ZIP+4
              </DataAppend>
            </DataAppends>
            <Link to="/guides/census/">Read more about data appends &raquo;</Link>
          </LeftColumn>
          <RightColumn>
            {this.state.totalCost === null && <div tw="h-full flex items-center justify-center">
              <div tw="text-xl hidden sm:block">Please enter your estimated number of lookups</div>
            </div>}
            <CostWrapper>
              {this.state.totalCost}
            </CostWrapper>
            {this.state.showDiscountDisclaimer && <CallOut>Pay as You Go volume discount is <strong>automatically</strong> applied to your statement at the time of each charge based on the usage of the previous month.</CallOut>}
            {this.hasAnyACSAppend() && <CallOut>The <em>Census Data</em> append is available for <strong>free</strong> with any Census ACS data append.</CallOut>}
            {this.state.totalCost !== null && <p tw="text-center mb-4 text-gray-600">Prices do not include local sales tax, if applicable</p>}
          </RightColumn>
        </Columns>
      </Wrapper>
    )
  }

  handleDataAppendClicked = name => {
    // Automatically add Census Data if any Census ACS append has been clicked
    if (name.indexOf('Census ACS') !== -1 && !this.hasCensusDataAppend()) {
      this.handleDataAppendClicked('Census Data');
    }

    let dataAppends = this.state.dataAppends;

    const currentPosition = dataAppends.indexOf(name);
    if (currentPosition !== -1) {
      dataAppends.splice(currentPosition, 1);
    } else {
      dataAppends.push(name);
    }

    const isRecurring = this.state.mode === 'recurring';
    const dataAppendsCount = this.calculateDataAppendsCount();
    const newCost = this.calculateNewCost(this.state.volumeAmount, isRecurring, dataAppendsCount);

    this.setState({
      dataAppends,
      totalCost: newCost.description,
      showDiscountDisclaimer: newCost.showDiscountDisclaimer,
    })
  }

  handleTabChanged = name => {
    const isRecurring = name === 'recurring';
    const dataAppendsCount = this.calculateDataAppendsCount();
    const newCost = this.calculateNewCost(this.state.volumeAmount, isRecurring, dataAppendsCount);

    this.setState({
      mode: name,
      totalCost: newCost.description,
      showDiscountDisclaimer: newCost.showDiscountDisclaimer,
    });
  }

  handleEstimateChange = e => {
    const isRecurring = this.state.mode === 'recurring';
    const amount = e.target.value;
    const dataAppendsCount = this.calculateDataAppendsCount();

    const newCost = this.calculateNewCost(amount, isRecurring, dataAppendsCount);

    this.setState({
      volumeAmount: amount,
      totalCost: newCost.description,
      showDiscountDisclaimer: newCost.showDiscountDisclaimer,
    });
  }

  calculateDataAppendsCount = () => {
    let dataAppendsCount = this.state.dataAppends.length;

    // The Census data append is free if any ACS data append has been selected
    if (this.hasAnyACSAppend() && this.hasCensusDataAppend()) {
      dataAppendsCount--;
    }

    return dataAppendsCount;
  }

  hasAnyACSAppend = () => this.state.dataAppends.join(',').indexOf('Census ACS') !== -1;
  hasCensusDataAppend = () => this.state.dataAppends.indexOf('Census Data') !== -1;

}

export default PricingCalculator